import React, { FC, PropsWithChildren, ReactNode } from "react";

import { DynamicTooltip } from "./DynamicTooltip";
import { StaticTooltip } from "./StaticTooltip";
import { StaticTooltipHtml } from "./StaticTooltipHtml";

import "./Tooltip.scss";

export interface TooltipProps extends PropsWithChildren {
  content: ReactNode;
  position?: "top" | "top-end" | "bottom" | "bottom-end" | "left" | "bottom-right";
  followCursor?: boolean;
  html?: boolean;
}

export const Tooltip: FC<TooltipProps> = ({ content, children, position = "bottom", followCursor, html }) => {
  if (followCursor) {
    return <DynamicTooltip content={content}>{children}</DynamicTooltip>;
  }

  if (html) {
    return (
      <StaticTooltipHtml content={content} position={position}>
        {children}
      </StaticTooltipHtml>
    );
  }

  return (
    <StaticTooltip content={content} position={position}>
      {children}
    </StaticTooltip>
  );
};
